import RadioButton from 'components/shared/RadioButton';
import { Heading1, Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useState } from 'react';
import LeastWantedLanguages from './charts/LeastWantedLanguages';
import LeastWantedTechnologies from './charts/LeastWantedTechnologies';
import MostUsedLanguages from './charts/MostUsedLanguages';
import MostUsedTechnologies from './charts/MostUsedTechnologies';
import {
  StyledContainer,
  StyledHeader,
  StyledHighlight,
  StyledSection,
  StyledSubsection,
  StyledSubsectionHeader,
  StyledSwitcher
} from './DevelopersSection.styled';
import LocationPreference from './LocationPreference';

const DevelopersSection: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  const [mostUsedLangs, setMostUsedLangs] = useState(true);
  const [leastWantedLangs, setLeastWantedLangs] = useState(true);

  return (
    <StyledSection>
      <StyledContainer>
        <StyledHeader>
          <Heading1 as="h2" editorial>
            {t('developers.title')}
          </Heading1>
          <p>{t('developers.desc')}</p>
        </StyledHeader>
        <StyledSubsection>
          <StyledSubsectionHeader>
            <Heading3>{t('developers.most-used.title')}</Heading3>
            <p>{t('developers.most-used.desc')}</p>
          </StyledSubsectionHeader>
          <StyledSwitcher>
            <RadioButton
              name="mostUsedTechs"
              id="mostUsedLangs"
              label={t('developers.most-used.switcher.languages')}
              onChange={() => setMostUsedLangs(true)}
              checked={mostUsedLangs}
            />
            <RadioButton
              name="mostUsedTechs"
              id="mostUsedTechs"
              label={t('developers.most-used.switcher.technologies')}
              onChange={() => setMostUsedLangs(false)}
              checked={!mostUsedLangs}
            />
          </StyledSwitcher>
          {mostUsedLangs && <MostUsedLanguages />}
          {!mostUsedLangs && <MostUsedTechnologies />}
        </StyledSubsection>
        <StyledSubsection>
          <StyledSubsectionHeader>
            <Heading3>{t('developers.least-wanted.title')}</Heading3>
            <p>{t('developers.least-wanted.desc')}</p>
          </StyledSubsectionHeader>
          <StyledSwitcher>
            <RadioButton
              name="leastWantedTechs"
              id="leastWantedLangs"
              label={t('developers.least-wanted.switcher.languages')}
              onChange={() => setLeastWantedLangs(true)}
              checked={leastWantedLangs}
            />
            <RadioButton
              name="leastWantedTechs"
              id="leastWantedTechs"
              label={t('developers.least-wanted.switcher.technologies')}
              onChange={() => setLeastWantedLangs(false)}
              checked={!leastWantedLangs}
            />
          </StyledSwitcher>
          {leastWantedLangs && <LeastWantedLanguages />}
          {!leastWantedLangs && <LeastWantedTechnologies />}
        </StyledSubsection>
        <StyledHighlight>
          <p>{t('developers.highlight')}</p>
        </StyledHighlight>
        <LocationPreference />
      </StyledContainer>
    </StyledSection>
  );
};

export default DevelopersSection;
